import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useMemo } from 'react';
import useWindowSize from '../../hooks/useWindowSize.js';
import Dropdown from '../Dropdown/index.js';
import { TableWrapper, Container, Dropdowns, DropdownWrapper, ErrorWrapper } from './Table.styles.js';

var SylexTable = function SylexTable(_ref) {
  var _tableEl, _tableEl2, _thead$props, _thead$props2, _tbody$props, _headers$leftCol, _headers$rightCol;
  var children = _ref.children,
    _ref$leftColumnAlignm = _ref.leftColumnAlignment,
    leftColumnAlignment = _ref$leftColumnAlignm === void 0 ? false : _ref$leftColumnAlignm,
    _ref$mobileComparison = _ref.mobileComparison,
    mobileComparison = _ref$mobileComparison === void 0 ? true : _ref$mobileComparison;
  var screenSize = useWindowSize();
  var isMobileView = (screenSize === null || screenSize === void 0 ? void 0 : screenSize.width) < 940;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    leftCol = _useState2[0],
    setLeftCol = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    rightCol = _useState4[0],
    setRightCol = _useState4[1];
  var _useState5 = useState({
      left: false,
      right: false
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var tableEl = null;
  if (Array.isArray(children)) {
    tableEl = children.find(function (child) {
      return (child === null || child === void 0 ? void 0 : child.type) === 'table';
    }) || null;
  } else if ((children === null || children === void 0 ? void 0 : children.type) === 'table') {
    tableEl = children;
  }
  var tableChildren = Array.isArray((_tableEl = tableEl) === null || _tableEl === void 0 || (_tableEl = _tableEl.props) === null || _tableEl === void 0 ? void 0 : _tableEl.children) ? tableEl.props.children : [(_tableEl2 = tableEl) === null || _tableEl2 === void 0 || (_tableEl2 = _tableEl2.props) === null || _tableEl2 === void 0 ? void 0 : _tableEl2.children].filter(Boolean);
  var thead = tableChildren.find(function (el) {
    return (el === null || el === void 0 ? void 0 : el.type) === 'thead';
  }) || null;
  var tbody = tableChildren.find(function (el) {
    return (el === null || el === void 0 ? void 0 : el.type) === 'tbody';
  }) || null;
  var headerRowEl = Array.isArray(thead === null || thead === void 0 || (_thead$props = thead.props) === null || _thead$props === void 0 ? void 0 : _thead$props.children) ? thead.props.children[0] : thead === null || thead === void 0 || (_thead$props2 = thead.props) === null || _thead$props2 === void 0 ? void 0 : _thead$props2.children;
  var headerRow = (headerRowEl === null || headerRowEl === void 0 ? void 0 : headerRowEl.props) || null;
  var bodyRows = (tbody === null || tbody === void 0 || (_tbody$props = tbody.props) === null || _tbody$props === void 0 ? void 0 : _tbody$props.children) || [];
  var headers = useMemo(function () {
    if (!(headerRow !== null && headerRow !== void 0 && headerRow.children)) return [];
    return headerRow.children.map(function (cell, index) {
      var label;
      try {
        var _cell$props;
        label = (cell === null || cell === void 0 || (_cell$props = cell.props) === null || _cell$props === void 0 || (_cell$props = _cell$props.children) === null || _cell$props === void 0 || (_cell$props = _cell$props[0]) === null || _cell$props === void 0 || (_cell$props = _cell$props.props) === null || _cell$props === void 0 || (_cell$props = _cell$props.children) === null || _cell$props === void 0 || (_cell$props = _cell$props[0]) === null || _cell$props === void 0 || (_cell$props = _cell$props.props) === null || _cell$props === void 0 ? void 0 : _cell$props.children) || "Column ".concat(index + 1);
      } catch (_unused) {
        label = "Column ".concat(index + 1);
      }
      return {
        value: index,
        label: typeof label === 'string' ? label : "Column ".concat(index + 1)
      };
    });
  }, [headerRow]);
  var showMobileComparison = isMobileView && mobileComparison && headers.length > 2;
  var onLeftSelect = function onLeftSelect(option) {
    if (option.value === rightCol) {
      setError(_objectSpread2(_objectSpread2({}, error), {}, {
        left: true
      }));
    } else {
      setLeftCol(option.value);
      setError({
        left: false,
        right: false
      });
    }
  };
  var onRightSelect = function onRightSelect(option) {
    if (option.value === leftCol) {
      setError(_objectSpread2(_objectSpread2({}, error), {}, {
        right: true
      }));
    } else {
      setRightCol(option.value);
      setError({
        left: false,
        right: false
      });
    }
  };
  var renderFilteredTable = function renderFilteredTable() {
    var _ref2;
    return /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, (_ref2 = [leftCol, rightCol]) === null || _ref2 === void 0 ? void 0 : _ref2.map(function (colIdx) {
      var _headerRow$children;
      return /*#__PURE__*/React__default.cloneElement(headerRow === null || headerRow === void 0 || (_headerRow$children = headerRow.children) === null || _headerRow$children === void 0 ? void 0 : _headerRow$children[colIdx], {
        key: colIdx
      });
    }))), /*#__PURE__*/React__default.createElement("tbody", null, bodyRows === null || bodyRows === void 0 ? void 0 : bodyRows.map(function (row, rowIdx) {
      var _row$props, _ref3;
      var cells = (row === null || row === void 0 || (_row$props = row.props) === null || _row$props === void 0 ? void 0 : _row$props.children) || [];
      return /*#__PURE__*/React__default.createElement("tr", {
        key: (row === null || row === void 0 ? void 0 : row.key) || "row-".concat(rowIdx)
      }, (_ref3 = [leftCol, rightCol]) === null || _ref3 === void 0 ? void 0 : _ref3.map(function (colIdx) {
        if (cells !== null && cells !== void 0 && cells[colIdx]) {
          return /*#__PURE__*/React__default.cloneElement(cells === null || cells === void 0 ? void 0 : cells[colIdx], {
            key: colIdx
          });
        }
        return /*#__PURE__*/React__default.createElement("td", {
          key: colIdx
        }, "\u2014");
      }));
    })));
  };
  return /*#__PURE__*/React__default.createElement(TableWrapper, {
    className: "leshen-table-wrapper",
    leftColumnAlignment: leftColumnAlignment
  }, showMobileComparison ? /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Dropdowns, null, /*#__PURE__*/React__default.createElement(DropdownWrapper, null, /*#__PURE__*/React__default.createElement(ErrorWrapper, {
    showError: error.left
  }, "Select a new option"), /*#__PURE__*/React__default.createElement(Dropdown, {
    placeholderText: headers === null || headers === void 0 || (_headers$leftCol = headers[leftCol]) === null || _headers$leftCol === void 0 ? void 0 : _headers$leftCol.label,
    options: headers,
    onChange: onLeftSelect
  })), /*#__PURE__*/React__default.createElement(DropdownWrapper, null, /*#__PURE__*/React__default.createElement(ErrorWrapper, {
    showError: error.right
  }, "Select a new option"), /*#__PURE__*/React__default.createElement(Dropdown, {
    placeholderText: headers === null || headers === void 0 || (_headers$rightCol = headers[rightCol]) === null || _headers$rightCol === void 0 ? void 0 : _headers$rightCol.label,
    options: headers,
    onChange: onRightSelect
  }))), renderFilteredTable()) : children);
};
var SylexTable$1 = SylexTable;

export { SylexTable$1 as default };
//# sourceMappingURL=index.js.map
